import { Outlet } from 'react-router-dom'

const Control = () => <Outlet />

export default Control
